import { interceptorMiddleware } from '../../../shared/services/interceptor.service';
import { createApi } from '@reduxjs/toolkit/query/react';
import { HttpMethods } from '../../../shared/constants/application.constant';
import { apiUrl } from '../constants/apiUrl.apiEvents';
import { BusinessDetais } from '../../../modules/businessInfo/utils/types.businessInfo';
import { ListResponse } from '../../../shared/utils/types.elements';
import { EventV2 } from '../../../modules/events/constants/types.events';
import { ExternalBusiness } from '../constants/constants.apiEvents';
import { getQueryParams, getUrl } from '../utils/util';

// Define a service using a base URL and expected endpoints
export const apiEventsApi = createApi({
    reducerPath: 'apiEvents',
    baseQuery: interceptorMiddleware,
    tagTypes: ['apiEvents'],
    endpoints: (builder) => ({
        getExternalBusinessDetails: builder.query<
            BusinessDetais,
            { id?: string }
        >({
            query: ({ id }) => {
                return {
                    url: `${apiUrl.BUSINESS_DETAILS}/${id}/`,
                    method: HttpMethods.GET,
                };
            },
        }),
        getExternalEventDetails: builder.query<
            EventV2,
            { id?: string; isWarehouse: boolean }
        >({
            query: ({ id, isWarehouse }) => {
                return {
                    url: `${getUrl(isWarehouse)}/${id}/`,
                    method: HttpMethods.GET,
                };
            },
            providesTags: ['apiEvents'],
        }),
        getExternalEvents: builder.query<
            ListResponse<EventV2>,
            { page: number; filters: any; isWarehouse: boolean }
        >({
            query: ({ page, isWarehouse, filters }) => {
                const queryParams = getQueryParams(page, filters);
                return {
                    url: `${getUrl(isWarehouse)}/${queryParams}`,
                    method: HttpMethods.GET,
                };
            },
            providesTags: ['apiEvents'],
        }),
        getExternalBusinesses: builder.query<
            ListResponse<ExternalBusiness>,
            { page: number; filters: any }
        >({
            query: ({ page, filters }) => {
                const queryParams = getQueryParams(page, filters);
                return {
                    url: `${apiUrl.EXTERNAL_BUSINESS}/${queryParams}`,
                    method: HttpMethods.GET,
                };
            },
            providesTags: ['apiEvents'],
        }),
        deleteExternalEventById: builder.mutation<
            { message: string },
            { id: number; isWarehouse: boolean }
        >({
            query: ({ id, isWarehouse }) => {
                return {
                    url: `${getUrl(isWarehouse)}/${id}/`,
                    method: HttpMethods.DELETE,
                };
            },
        }),
        deleteExternalBusinessById: builder.mutation<
            { message: string },
            { id: number }
        >({
            query: ({ id }) => {
                return {
                    url: `${apiUrl.EXTERNAL_BUSINESS}/${id}/`,
                    method: HttpMethods.DELETE,
                };
            },
        }),
    }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useGetExternalBusinessDetailsQuery,
    useGetExternalEventDetailsQuery,
    useGetExternalEventsQuery,
    useGetExternalBusinessesQuery,
    useDeleteExternalEventByIdMutation,
    useDeleteExternalBusinessByIdMutation,
} = apiEventsApi;
